"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRate = exports.formatPercentage = exports.formatExecuteMsgNumber = exports.executeMsgFormatter = exports.formatFluidDecimalPoints = exports.formatInteger = exports.formatDemimal = exports.MAX_EXECUTE_MSG_DECIMALS = void 0;
var big_js_1 = __importDefault(require("big.js"));
var numeral_1 = __importDefault(require("numeral"));
exports.MAX_EXECUTE_MSG_DECIMALS = 18;
var formatDemimal = function (_a) {
    var decimalPoints = _a.decimalPoints, delimiter = _a.delimiter;
    return function (n, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = ''; }
        var num = big_js_1.default(big_js_1.default(n)
            .mul(Math.pow(10, decimalPoints))
            .toFixed()
            .split('.')[0])
            .div(Math.pow(10, decimalPoints))
            .toFixed();
        if (num === 'NaN')
            return fallbackValue;
        var _a = __read(num.split('.'), 2), i = _a[0], d = _a[1];
        var ii = delimiter ? numeral_1.default(i).format('0,0') : i;
        var dd = d ? '.' + d : '';
        return ii + dd;
    };
};
exports.formatDemimal = formatDemimal;
var formatInteger = function (_a) {
    var delimiter = _a.delimiter;
    return function (n) {
        var num = big_js_1.default(n).toFixed();
        var _a = __read(num.split('.'), 1), i = _a[0];
        return delimiter ? numeral_1.default(i).format('0,0') : i;
    };
};
exports.formatInteger = formatInteger;
function formatFluidDecimalPoints(n, numDecimalPoints, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.delimiter, delimiter = _c === void 0 ? true : _c, _d = _b.fallbackValue, fallbackValue = _d === void 0 ? '' : _d;
    var num = big_js_1.default(big_js_1.default(n)
        .mul(Math.pow(10, numDecimalPoints))
        .toFixed()
        .split('.')[0])
        .div(Math.pow(10, numDecimalPoints))
        .toFixed();
    if (num === 'NaN')
        return fallbackValue;
    var _e = __read(num.split('.'), 2), i = _e[0], d = _e[1];
    var ii = delimiter ? numeral_1.default(i).format('0,0') : i;
    var dd = d ? '.' + d : '';
    return ii + dd;
}
exports.formatFluidDecimalPoints = formatFluidDecimalPoints;
// ---------------------------------------------
// formatters
// ---------------------------------------------
exports.executeMsgFormatter = exports.formatDemimal({
    decimalPoints: exports.MAX_EXECUTE_MSG_DECIMALS,
    delimiter: false,
});
var percentageFormatter = exports.formatDemimal({
    decimalPoints: 2,
    delimiter: true,
});
// ---------------------------------------------
// functions
// ---------------------------------------------
exports.formatExecuteMsgNumber = exports.executeMsgFormatter;
var formatPercentage = function (n) {
    return percentageFormatter(n);
};
exports.formatPercentage = formatPercentage;
var formatRate = function (n) {
    return percentageFormatter(big_js_1.default(n).mul(100));
};
exports.formatRate = formatRate;
//# sourceMappingURL=unit.format.js.map